import { render, staticRenderFns } from "./PreachingTour.vue?vue&type=template&id=56f645c8&scoped=true&"
import script from "./PreachingTour.vue?vue&type=script&lang=js&"
export * from "./PreachingTour.vue?vue&type=script&lang=js&"
import style0 from "./PreachingTour.vue?vue&type=style&index=0&id=56f645c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f645c8",
  null
  
)

component.options.__file = "PreachingTour.vue"
export default component.exports